module.exports = __webpack_public_path__ + "images/category_lp/estate_sale/main-bg_7571facdd71f565e80c115d968c6f619.jpg";